import { Injectable } from '@angular/core';
import { UpdateUnitPreferences } from 'app/check-ppa/mutations/unit-preferences.query';
import { GetUnitPreferencesQuery } from 'app/check-ppa/queries/unit-preferences.query';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';


/**
 * @deprecated
 * This service is deprecated and will be removed in future versions. Please use UserPreferencesService instead.
 */

@Injectable({
  providedIn: 'root'
})
export class UserPreferencesUnitSettingsService {
  private timeFormat: string;
  private dateFormat: string;
  private decimalThousandSeparators: { decimalSeparator: string, thousandSeparator: string };

  public unitPreference$: BehaviorSubject<string> = new BehaviorSubject<string>('');

  constructor(
    private UpdateUnitPreferences: UpdateUnitPreferences,
    private GetUnitPreferencesQuery: GetUnitPreferencesQuery
  ) {
    this.getUnitPreferencesPromise().then((response: string) => {
      this.timeFormat = JSON.parse(response).timeFormat;
      this.dateFormat = JSON.parse(response).dateFormat;
      this.decimalThousandSeparators = { decimalSeparator: JSON.parse(response).decimalSeparator || ".", thousandSeparator: JSON.parse(response).thousandSeparator || "'" };
      this.unitPreference$.next(response);
    });
  }

  public getUnitPreferencesPromise = () => this.GetUnitPreferencesQuery.fetch({
    variables: {},  fetchPolicy: 'network-only' })
    .pipe(map(r => r.data.user.preferences.unitFormatPreferences.active.value)).toPromise();

  public getTimeFormat = () => this.timeFormat || 'HH:mm';
  public getDateFormat = () => this.dateFormat || 'dd MMM yyyy';
  public getDecimalThousandSeparator = () => this.decimalThousandSeparators || { decimalSeparator: ".", thousandSeparator: "'" };

  public updateUnitPreferences = (preferences: any): any => {
    this.UpdateUnitPreferences.mutate({ variables: { preferences }}).toPromise();
    this.timeFormat = JSON.parse(preferences["unitFormatPreferences"]).timeFormat;
    this.dateFormat = JSON.parse(preferences["unitFormatPreferences"]).dateFormat;
    this.decimalThousandSeparators = {
      decimalSeparator: JSON.parse(preferences["unitFormatPreferences"]).decimalSeparator,
      thousandSeparator: JSON.parse(preferences["unitFormatPreferences"]).thousandSeparator
    };
  }
}
